import { ApiError, formatMoney } from '@edil/api-client';

export const money = (santim: string | null | undefined) => (santim == null ? '—' : formatMoney(santim, 'ETB'));

export function dateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  return new Intl.DateTimeFormat('en-GB', { dateStyle: 'medium', timeStyle: 'short', timeZone: 'Africa/Addis_Ababa' }).format(new Date(iso));
}

/** "4 min", "2 h 5 min", "3 d" since `iso`. */
export function age(iso: string | null | undefined, now = Date.now()): string {
  if (!iso) return '—';
  const m = Math.max(0, Math.floor((now - Date.parse(iso)) / 60_000));
  if (m < 60) return `${m} min`;
  if (m < 24 * 60) return `${Math.floor(m / 60)} h ${m % 60} min`;
  return `${Math.floor(m / 1440)} d`;
}

export const shortId = (id: string | null | undefined) => (id ? id.slice(0, 8) : '—');

export function errorText(e: unknown): string {
  if (e instanceof ApiError) {
    // Staff see the server's reason when it gives one, e.g. which agent already has a Telegram username.
    const { field, reason } = e.details as { field?: unknown; reason?: unknown };
    const why = typeof reason === 'string' ? ` ${typeof field === 'string' ? `${field.replace(/_/g, ' ')}: ` : ''}${reason}.` : '';
    return `${e.message}${why} (${e.code})`;
  }
  return String(e);
}

/** Today in Addis Ababa as YYYY-MM-DD. */
export function eatDay(offsetDays = 0): string {
  return new Date(Date.now() + 3 * 3600_000 + offsetDays * 86_400_000).toISOString().slice(0, 10);
}
